<template>
  <div class="admin col-12">
    <div class="row">
      <div class="col-3">
        <div class="row">
          <div class="col-12 row-header">Pot Sizes</div>
        </div>
        <div class="scrolling-table" v-show="!loading">
          <template v-for="temp in pot_sizes">
            <div
              class="row clickable"
              :key="temp.id"
              v-show="temp.active == !show_deleted"
              v-bind:class="{ selected: temp == item }"
              @click="_itemSelected(temp)"
            >
              <div class="col-12">
                {{ temp.description }}
              </div>
            </div>
          </template>
        </div>
      </div>
      <div class="col-9">
        <div class="row">
          <PotSizeDetail
            :selectedItem="item"
            class="col-12"
            v-show="showPotSizeDetail"
            ref="pot_size"
            @new="_new_item"
          />
        </div>
      </div>
    </div>

    <CreatePotSize
      ref="pot_sizes_modal"
      v-show="showCreatePotSize"
      @close="_closeNewModal"
    />

    <div class="row">
      <div class="col-3">
        <input type="checkbox" id="show_deleted" @click="_show_deleted" />
        <label for="show_deleted">Show Deleted</label>
      </div>
    </div>
  </div>
</template>

<script>
import PotSizeDetail from "@/components/admin/inventory/detail/PotSizeDetail.vue";
import CreatePotSize from "@/components/admin/inventory/create/CreatePotSize.vue";
import { mapState, mapActions } from "vuex";

export default {
  name: "ManagePotSizes",

  // DATA
  data: () => ({
    item: null,
    loading: false,
    show_deleted: false,
    showCreatePotSize: false,
    showPotSizeDetail: true,
  }),

  // COMPUTED
  computed: {
    ...mapState("inventory", ["pot_sizes", "new_pot_size"]),
  },

  // MOUNTED
  mounted() {
    this.$nextTick(() => {
      this.getPotSizes();
    });
  },

  // WATCH
  watch: {
    new_plant_botany(new_value) {
      this.item = new_value;
      this.$refs.pot_sizes_modal.clear();
    },
  },

  // METHODS
  methods: {
    ...mapActions("inventory", ["apiCreatePotSize", "getPotSizes"]),

    _show_deleted() {
      this.show_deleted = !this.show_deleted;
    },

    _save() {
      this.$refs.pot_size.save();
    },

    _new_item() {
      this.showCreatePotSize = true;
    },

    _closeNewModal() {
      this.showCreatePotSize = false;
    },

    _showTab(index) {
      this.tab = index;
    },

    _itemSelected(item) {
      this.item = item;
      this.showPotSizeDetail = true;
    },

    _delete_item() {
      if (this.item != null && this.item.id > 0) {
        this.item.active = !this.item.active;
        this.apiSavePotSize(this.item);
      }
    },
  },

  // COMPONENTS
  components: {
    PotSizeDetail,
    CreatePotSize,
  },
};
</script>
